import { FETCH_FINANCIAL_DASHBOARD } from './FinancialDashboardActions'

const INITIAL_STATE = {
  totalReceitas: 0,
  totalDespesas: 0,
  balance: 0,
  receitasToday: 0,
  despesasToday: 0,
  balanceToday: 0,
  currentMonth: '',
  refreshing: false,
  filters: {},
  banksBalance: [],
  monthBalance: [],
  banksTotal: 0,

  payments: 0,
  paymentsDue: 0,
  paymentsLate: 0,
  paymentsTotal: 0,

  // laundryDue: 0,
  // laundryTotal: 0,
  // laundryLate: 0,
  // clientLate: 0,
  // clientDue: 0,
  // clientTotal: 0,

  receipts: 0,
  receiptsLate: 0,
  receiptsDue: 0,
  receiptsTotal: 0,

  roi: {
    services: 0,
    roi: 0,
  },

  concludedReceivables: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_FINANCIAL_DASHBOARD.SUCCESS: {
      const d = action.payload.data
      return {
        ...state,
        currentMonth: d.reference_date,
        monthBalance: d?.month_balance,

        totalReceitas: d.balance?.receitas,
        totalDespesas: d.balance?.despesas,
        balance: d.balance?.balance,

        banksBalance: d.banks?.balance,
        banksTotal: d.banks?.total,

        payments: d.payments?.calculated,
        paymentsDue: d.payments?.due,
        paymentsLate: d.payments?.late,
        paymentsTotal: d.payments?.total,

        receipts: d.receipts?.calculated,
        receiptsLate: d.receipts?.late,
        receiptsDue: d.receipts?.due,
        receiptsTotal: d.receipts?.total,
        roi: {
          services: d.roi?.services,
          roi: d.roi?.roi,
        },

        concludedReceivables: d.concludedReceivables,

        refreshing: false,
      }
    }
    case FETCH_FINANCIAL_DASHBOARD.ACTION:
      return {
        ...state,
        refreshing: true,
      }
    case FETCH_FINANCIAL_DASHBOARD.FAILURE:
      return {
        ...state,
        refreshing: false,
      }
    default:
      return state
  }
}
